package com.nonopn.skywatcher.app.utils

import eu.codlab.files.VirtualFile
import korlibs.io.lang.toByteArray

suspend fun VirtualFile.write(text: String) {
    write(text.toByteArray())
}

suspend fun VirtualFile.readStringIfExists() = if (exists()) {
    readString()
} else {
    null
}